// extracted by mini-css-extract-plugin
export default {"inputGroup":"UpdateAddressModal_inputGroup__KmVEi","fullWidth":"UpdateAddressModal_fullWidth__SO3T7","halfWidth":"UpdateAddressModal_halfWidth__wdmYD"};